import React, { useEffect, useRef, useState } from 'react';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const currentSection = sectionRef.current;
    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  return (
    <section 
      id="about" 
      className="py-32 px-8 bg-[#fafafa] min-h-screen flex items-center max-md:py-20 max-md:px-6" 
      ref={sectionRef}
    >
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-[1fr_1.5fr] gap-20 items-center max-lg:gap-12">
        <div className={`relative transition-all duration-800 ease-[cubic-bezier(0.16,1,0.3,1)] max-lg:max-w-[400px] max-lg:mx-auto ${
          isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
        }`}>
          <div className="absolute top-[15px] -left-[15px] w-full h-full border-2 border-crimson rounded-xl -z-[1]"></div>
          <img 
            src="/img/barbara_neu.JPG" 
            alt="Barbara Wolfinger"
            className="w-full h-auto border border-zinc-200 rounded-xl transition-transform duration-400 ease-[cubic-bezier(0.16,1,0.3,1)] hover:scale-[1.02]"
          />
        </div>
        
        <div className={`transition-all duration-800 ease-[cubic-bezier(0.16,1,0.3,1)] delay-200 ${
          isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
        }`}>
          <h2 className="font-display text-[3.5rem] font-bold text-zinc-900 tracking-tighter leading-tight mb-4 text-left max-lg:text-center max-md:text-[2.5rem]">
            About <span className="text-crimson">me</span>
          </h2>
          
          <h3 className="font-sans text-[1.4rem] text-zinc-500 font-semibold mb-8 tracking-tight max-lg:text-center">
            Barbara Wolfinger
          </h3>
          
          <p className="font-sans text-base text-zinc-500 font-normal leading-[1.7] tracking-tight mb-5">
            Ich bin Barbara Wolfinger, Gründerin und Künstlerin hinter einzigartigen Tauleinen und getakeltem Leinenwerk. Mit einer Leidenschaft für traditionelles Handwerk und einem Auge für zeitloses Design, schaffe ich handgefertigte Stücke, die sowohl praktisch als auch stilvoll sind. Jedes meiner Werke vereint die Robustheit des Tauwerks mit der Eleganz des Takelns, wobei Nachhaltigkeit und Qualität im Vordergrund stehen. Entdecken Sie ein Sortiment, das Tradition, Handwerkskunst und modernes Design harmonisch verbindet.
          </p>
          
          <p className="font-sans text-base text-zinc-500 font-normal leading-[1.7] tracking-tight mt-6">
            Willkommen in meiner Welt des handgefertigten Leinenwerks, wo jedes Stück eine Geschichte erzählt.
          </p>
          
          <div className="flex gap-12 mt-12 pt-8 border-t border-zinc-200 max-lg:justify-center max-md:flex-wrap max-md:gap-8">
            <div className="flex flex-col items-center text-center max-md:flex-1 max-md:basis-[30%]">
              <span className="font-sans text-[2.5rem] font-extrabold text-crimson mb-2 block tracking-tight">100%</span>
              <span className="font-sans text-sm text-zinc-500 font-medium uppercase tracking-[0.08em]">Handarbeit</span>
            </div>
            <div className="flex flex-col items-center text-center max-md:flex-1 max-md:basis-[30%]">
              <span className="font-sans text-[2.5rem] font-extrabold text-crimson mb-2 block tracking-tight">♥</span>
              <span className="font-sans text-sm text-zinc-500 font-medium uppercase tracking-[0.08em]">Mit Liebe</span>
            </div>
            <div className="flex flex-col items-center text-center max-md:flex-1 max-md:basis-[30%]">
              <span className="font-sans text-[2.5rem] font-extrabold text-crimson mb-2 block tracking-tight">∞</span>
              <span className="font-sans text-sm text-zinc-500 font-medium uppercase tracking-[0.08em]">Qualität</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

